import type { ReactNode } from 'react';
import styles from './FullscreenLayout.module.css';

export interface FullscreenLayoutProps {
  /** Title in the top bar. */
  title: ReactNode;
  /** Small line next to the title, e.g. the date. */
  subtitle?: ReactNode;
  /** Action on the left, typically a "close" link. */
  leading?: ReactNode;
  /** Actions on the right. */
  actions?: ReactNode;
  /** Sticky bar at the bottom, e.g. the total and the checkout button. */
  footer?: ReactNode;
  children: ReactNode;
}

/**
 * A page without app navigation for focused work on tablets and phones,
 * e.g. the market mode (MKT-001).
 */
export function FullscreenLayout({
  title,
  subtitle,
  leading,
  actions,
  footer,
  children,
}: FullscreenLayoutProps) {
  return (
    <div className={styles.page}>
      <header className={styles.bar}>
        {leading && <div className={styles.leading}>{leading}</div>}
        <div className={styles.titles}>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </header>
      <main className={styles.main}>{children}</main>
      {footer && <footer className={styles.footer}>{footer}</footer>}
    </div>
  );
}
